import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  valuesMultipleSelectDeliveryAssociateStatus: [],
  valuesMultipleSelectDriverType: [],
  valuesMultipleSelectVehicleOwnership: [],
  valuesMultipleSelectTripStatus: [],
  valuesMultipleSelectOrderFrom: [],
}

const globalMultipleSelectValuesSlices = createSlice({
  name: "globalMultipleSelectValues",
  initialState,
  reducers: {
    setValuesMultipleSelectDeliveryAssociateStatus: (state, action) => {
      state.valuesMultipleSelectDeliveryAssociateStatus = action.payload
    },
    setValuesMultipleSelectDriverType: (state, action) => {
      state.valuesMultipleSelectDriverType = action.payload
    },
    setValuesMultipleSelectVehicleOwnership: (state, action) => {
      state.valuesMultipleSelectVehicleOwnership = action.payload
    },
    setValuesMultipleSelectTripStatus: (state, action) => {
      state.valuesMultipleSelectTripStatus = action.payload
    },
    setValuesMultipleSelectOrderFrom: (state, action) => {
      state.valuesMultipleSelectOrderFrom = action.payload
    },
  }
});

export const { 
  setValuesMultipleSelectDeliveryAssociateStatus,
  setValuesMultipleSelectDriverType,
  setValuesMultipleSelectVehicleOwnership,
  setValuesMultipleSelectTripStatus,
  setValuesMultipleSelectOrderFrom
} = globalMultipleSelectValuesSlices.actions;

export default globalMultipleSelectValuesSlices.reducer;
